import Const from './Const';
import DiscussionTranslations from './DiscussionTranslations';
import ForumMessage from './ForumMessage';
import BroadcastMessage from '../../common/BroadcastMessage';
import BaseUtils from "../../common/BaseUtils";
import Event = JQuery.Event;

/**
 *
 */
export default class XarticlesForum {

    private $body: any;
    private $loader: any;
    private $spinner: any;
    private $header: any;
    private $sortHeader: any;
    private $sortOption: any;
    private $sortOptions: any;
    private $sortOptionsAsc: any;
    private $sortOptionsDesc: any;
    private $sortMenu: any;
    private $sortMenuMobile: any;
    private $sortMenuMobileOptions: any;
    private $sortMenuAsc: any;
    private $sortMenuDesc: any;
    private $form: any;
    private $warningPanel: any;
    private $warningMessage: any;
    private $controlBar: any;
    private $messageContainer: any;
    private $messageBlock: any;
    private $messageText: any;
    private $textarea: any;
    private $closeCross: any;
    private type: string;
    private uid: string;
    private uuid: string;
    private objectId: string;
    private groupId: string;
    private topicId: string;
    private theme: string;
    private $loginBlock: any;
    private $submitBlock: any;
    private $submitButton: any;
    private forumUrl: string;
    private refreshComments: boolean;
    private force: boolean;
    private sortMode: number;
    private lang: string;
    private storageType = 'sessionStorage'; // 'sessionStorage', 'localStorage'
    private hasStorage = false;
    private trans: DiscussionTranslations;
    private isMobile: boolean;

    constructor(forumUrl: string, refresh: boolean, lang: string, theme: string) {
        this.$body = $('body');
        this.$loader = $('.loader');
        this.$spinner = $('.spinner');
        this.$header = $('.header');
        this.$sortHeader = $('.sort-header');
        this.$sortOption = $('[data-role="sort-option"]');
        this.$sortOptions = $('[class^="sort-options--"]');
        this.$sortOptionsAsc = $('.sort-options--asc');
        this.$sortOptionsDesc = $('.sort-options--desc');
        this.$sortMenu = $('[data-role="sort-menu"]');
        this.$sortMenuMobile = $('[data-role="sort-menu-mobile"]');
        this.$sortMenuMobileOptions = $('[data-role="sort-menu-mobile-options"]');
        this.$sortMenuAsc = $('.sort-menu--asc');
        this.$sortMenuDesc = $('.sort-menu--desc');
        this.$form = $('form.comment');
        this.$warningPanel = $('.warning-panel');
        this.$warningMessage = $('.warning-panel > span');
        this.$controlBar = $('.control-bar');
        this.$messageContainer = $('.message-container');
        this.$messageBlock = $('.message');
        this.$messageText = $('.message > span');
        this.$textarea = $('textarea');
        this.$closeCross = $('.close-cross');
        this.type = <string>$('input[name="type"]').val();
        this.uid = <string>$('input[name="uid"]').val();
        this.uuid = <string>$('input[name="uuid"]').val();
        this.objectId = this.type !== Const.TYPE_DEFAULT ? this.uuid : '';
        this.groupId = <string>$('input[name="groupId"]').val();
        this.topicId = <string>$('input[name="topicId"]').val();
        this.force = $('input[name="force"]').val() == 1;
        this.theme = theme;
        this.$loginBlock = $('.login-block');
        this.$submitBlock = $('.submit-block');
        this.$submitButton = $('[type="submit"]');
        this.forumUrl = forumUrl;
        this.refreshComments = refresh;
        this.sortMode = this.getSortMode();
        this.lang = typeof lang === 'string' ? lang.toLowerCase() : 'ru';
        this.storageType = 'sessionStorage'; // 'sessionStorage', 'localStorage'
        this.hasStorage = this.supports_html5_storage();
        this.trans = new DiscussionTranslations(this.lang);
        this.isMobile = this.checkIsMobile();
    }

    run(message: string = ''): void {
        this.applyTheme();
        this.setupControlBar();
        this.getPostFromStorage();
        this.initListeners();
        this.showSortMenu();

        if (this.refreshComments) {
            this.broadcastMessage(Const.MESSAGE_REFRESH, this.sortMode);
        }

        if (message.length) {
            this.$textarea.val(message);
            this.expandPanel();
        }
    }

    /**
     * Настраиваем тему
     */
    private applyTheme(): void {
        let theme: string = this.theme = Const.THEME_OLD ? this.theme : Const.THEME_NEW;
        this.$spinner.addClass(theme);
        this.$submitButton.addClass(theme);
    }

    /**
     * В зависимости от статуса пользователя (анонимный или авторизованный)
     * выводим либо кнопку "Отправить" либо блок авторизации
     */
    private setupControlBar(): void {
        if (this.uid === Const.ANONYMOUS) {
            this.$loginBlock.removeClass(Const.CLASS_HIDE);
            this.$submitBlock.addClass(Const.CLASS_HIDE);
        } else {
            this.$loginBlock.addClass(Const.CLASS_HIDE);
            this.$submitBlock.removeClass(Const.CLASS_HIDE);
        }
    }

    // noinspection JSMethodCanBeStatic
    /**
     * Получение метода сортировки сообщений
     *
     * @return {string}
     */
    private getSortMode(): number {
        let sortMode = BaseUtils.getCookie(Const.COOKIE_SORT);
        return sortMode != 'NaN' ? Number(sortMode) : Const.SORT_ASC;
    }

    /**
     * Инициализация слушателей всяких разных событий
     */
    private initListeners(): void {
        let eventType: string = this.isMobile ? 'click' : 'mouseover';
        // показываем меню сортировки
        this.$sortMenu
            .on(eventType, (e) => {
                this.showSortOptions();
            });

        // обработка клика по пункту меню сортировки
        this.$sortOption
            .on('click', (e) => {
                this.saveSortOrder(e);
                this.showSortMenu();
            });

        // обработка клика по опциям селекта (мобильное меню сортировки)
        this.$sortMenuMobileOptions
            .on('change', (e) => {
                this.saveSortOrder(e);
                this.showSortMenu();
            });

        this.$textarea
            // при получении фокуса, увеличиваем высоту блока ввода
            .on('focus', () => {
                this.setFormBorder(Const.FORM_BORDER_FOCUSED);
                this.addPadding();
                this.clearMessageBlock();
                this.expandPanel();
                this.broadcastMessage(Const.MESSAGE_RESIZE);
            })
            .on('blur', (event) => {
                this.setFormBorder(Const.FORM_BORDER_DEFAULT);
                /*
                      if (event.currentTarget.textLength === 0) {
                        this.removePadding();
                        this.shrinkPanel();
                        this.broadcastMessage(Const.MESSAGE_RESIZE);
                      }
                */
            })
            // при вводе текста, меняем размер шрифта на более мелкий, заменяя текст якобы плейсхолдера
            .on('input', function () {
                let $txtArea = $(<HTMLTextAreaElement>this);
                if ($txtArea.val() === '') {
                    $txtArea.css('font-size', Const.TEXT_AREA.shrinked.fontSize)
                } else {
                    $txtArea.css('font-size', Const.TEXT_AREA.expanded.fontSize)
                }
            });

        // скрываем инфо-полоску над полем ввода
        this.$closeCross.on('click', (e: any) => {
            $(e.target.parentElement).addClass(Const.CLASS_HIDE);
            this.broadcastMessage(Const.MESSAGE_RESIZE);
        });

        /**
         * При покидании фрейма, прячем меню сортировки, если оно отображается
         */
        this.$body
            .on('mouseleave', () => {
                if ($(this.$sortOptions).is(':visible')) {
                    $(this.$sortOptions).hide();
                }
            });

        $(window)
            // при кликах в пределах фрейма, прячем меню сортировки, если оно отображается
            .on('click', () => {
                if ($(this.$sortOptions).is(':visible')) {
                    $(this.$sortOptions).hide();
                }
            })
            // при ресайзе фрейма отправляем сообщение хосту, чтобы он поменял размер окна для фрейма
            .on('resize', () => {
                this.broadcastMessage(Const.MESSAGE_RESIZE);
            });

        // приём сообщений от хоста (работа через jQuery или Zepto не подходит),
        // т.к. там не заполняется поле data
        window.addEventListener('message', (e: any) => {
            if (e.data.action) {
                switch (e.data.action) {
                    case Const.MESSAGE_INFO:
                        this.displayWarning(e.data.message, Const.CLASS_WARN);
                        this.shrinkPanel();
                        this.broadcastMessage(Const.MESSAGE_RESIZE);
                        break;
                    case Const.MESSAGE_RELOAD_BOARD:
                        this.broadcastMessage(Const.MESSAGE_RELOAD_BOARD);
                        break;
                }
            }
        });
    }

    // noinspection JSMethodCanBeStatic
    /**
     * Проверка броузера на "мобильную принадлежность"
     * @return {boolean}
     */
    private checkIsMobile(): boolean {
        return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(Cri|hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dol(f|ph)in|Skyfire|Zune/i.test(navigator.userAgent);
    }

    /**
     * Отображает иконку меню сортировки, согласно дефолтному или
     * уже указанному ранее значению, сохранённому в куке
     */
    private showSortMenu(): void {
        this.hideSortMenu();
        this.hideSortOptions();
        if (this.isMobile) {
            this.prepareMobileMenu();
        }
        switch (this.sortMode) {
            case Const.SORT_DESC:
                this.$sortMenuDesc.show();
                break;
            case Const.SORT_ASC:
                this.$sortMenuAsc.show();
                break;
        }
    }

    /**
     * Вызывает/отображает тот или иной вид меню сортировки
     */
    private showSortOptions(): void {
        if (!this.isMobile) {
            switch (this.sortMode) {
                case Const.SORT_DESC:
                    this.$sortOptionsDesc.show();
                    break;
                case Const.SORT_ASC:
                    this.$sortOptionsAsc.show();
                    break;
            }
        }
    }

    /**
     * Скрывает все иконки меню сортировки
     */
    private hideSortMenu(): void {
        this.$sortMenuAsc.hide();
        this.$sortMenuDesc.hide();
    }

    /**
     * Скрывает все варианты меню сортировки
     */
    private hideSortOptions(): void {
        this.$sortOptionsAsc.hide();
        this.$sortOptionsDesc.hide();
    }

    private prepareMobileMenu(): void {
        this.$sortMenuAsc.addClass('mobile-modification');
        this.$sortMenuDesc.addClass('mobile-modification');
        let options = $('[data-role="sort-menu-mobile-options"] option');
        if (this.sortMode === Const.SORT_ASC) {
            options[0].setAttribute('selected', 'selected');
        } else {
            options[1].setAttribute('selected', 'selected');
        }
    }

    /**
     * Меняет цвет бордюра у формы при получении или потере фокуса полем ввода
     *
     * @param {string} borderClass
     */
    private setFormBorder(borderClass: string): void {
        this.$form.removeClass(Const.FORM_BORDER_FOCUSED);
        this.$form.addClass(borderClass);
    }

    /**
     * Изменение отступов и высоты textarea при получении фокуса
     */
    private addPadding(): void {
        this.$textarea.addClass(Const.CLASS_TA_FOCUSED);
    }

    /**
     * Изменение отступов и высоты textarea при потере фокуса
     */
    private removePadding(): void {
        this.$textarea.removeClass(Const.CLASS_TA_FOCUSED);
    }

    /**
     * Запоминаем порядок сортировке в куке
     * Перенастраиваем меню сортировки
     * @param {JQuery.TriggeredEvent} event
     */
    private saveSortOrder(event: JQuery.TriggeredEvent): void {
        let option = $(event.currentTarget),
            sortMode = this.getSortMode(),
            newSortMode = this.isMobile ? Number(option.val()) : Number(option.attr('value'));
        if (newSortMode !== sortMode) {
            this.sortMode = newSortMode;
            BaseUtils.setCookie(Const.COOKIE_SORT, newSortMode, {expires: Const.COOKIE_LIFETIME});
            this.broadcastMessage(Const.MESSAGE_REFRESH, this.sortMode);
        }
    }

    /**
     * вызов модальных окон регистрации
     * @param who
     * @returns {boolean}
     */
    open_xlogin(who: string): boolean {
        this.savePostIntoStorage();
        let url = this.forumUrl + '/ucp.php?mode=xlogin&from=' + who + '&type=' + this.type + '&lang=' + this.lang + '&theme=' + this.theme;
        window.open(url, 'forum_xlogin', 'height=620,width=600,resizable=no,scrollbars=no');
        return false;
    }

    /**
     * Вывод сообщения
     * @param {string} message
     * @param {string} type
     */
    private displayMessageBlock(message: string, type: string = Const.CLASS_INFO): void {
        this.$messageBlock.addClass(type);
        switch (type) {
            case Const.CLASS_INFO:
                this.$controlBar.addClass(Const.CLASS_FILL_INFO);
                break;
            case Const.CLASS_WARN:
                this.$controlBar.addClass(Const.CLASS_FILL_WARN);
                break;
            case Const.CLASS_ERROR:
                this.$controlBar.addClass(Const.CLASS_FILL_ERROR);
                break;
        }
        this.$messageText.html(this.trans.getText(message));
        this.$messageBlock.removeClass(Const.CLASS_HIDE);
    }

    /**
     * Очистка и скрытие блока сообщений
     */
    private clearMessageBlock(): void {
        this.$controlBar.removeClass(Const.CLASS_FILL_INFO);
        this.$controlBar.removeClass(Const.CLASS_FILL_WARN);
        this.$controlBar.removeClass(Const.CLASS_FILL_ERROR);
        this.$messageBlock.addClass(Const.CLASS_HIDE);
        this.$messageBlock.removeClass(Const.CLASS_ERROR);
        this.$messageText.html('');
    }

    /**
     *
     * @param {Event} e
     */
    public submit(e: Event): void {
        let event = e || window.event;
        event.preventDefault();
        if (this.validate()) {
            let data = {
                message: this.$textarea.val(),
                type: this.type,
                lang: this.lang,
                uid: this.uid,
                uuid: this.uuid,
                object_id: this.objectId,
                group_id: this.groupId,
                force: this.force,
                topic_id: this.topicId
            };
            this.doAjax(data, this.success.bind(this));
        }
    }

    /**
     * Валидация введённого текста
     * @return {boolean}
     */
    private validate(): boolean {
        let result = true, text = <string>this.$textarea.val();
        text = text.trim();
        text = BaseUtils.removeNonLetters(text);
        if (text.length < Const.POST_MIN_LENGTH) {
            this.displayMessageBlock('POST_TOO_SHORT', Const.CLASS_ERROR);
            this.broadcastMessage(Const.MESSAGE_RESIZE);
            result = false;
        } else {
            this.runAnimatedLoader();
            this.clearMessageBlock();
            this.removePostFromStorage();
        }
        return result;
    }

    /**
     * Общий метод для отправки запроса
     * @param data
     * @param success
     */
    private doAjax(data: any, success: any): void {
        $.ajax({
            url: Const.FORUM_ENDPOINT,
            data: data,
            dataType: 'jsonp',
            success: success,
            error: (response) => {
                this.stopAnimatedLoader();
                console.log('server error', response);
            }
        }).then(() => {
            this.stopAnimatedLoader();
        });
    }

    /**
     * Callback успешного ответа на запрос "получить комментарии"
     * @param response
     */
    private success(response: any): void {
        switch (response.code) {
            case Const.RESULT_OK:
                this.$textarea.val('');
                this.shrinkPanel();
                this.updateSortMenuHeader(response.data.topic_replies);
                if (!response.data.approved) {
                    this.displayWarning(this.trans.getText(Const.POST_NOT_APPROVED));
                }
                this.topicId = response.data.topic_id;
                this.broadcastMessage(Const.MESSAGE_REFRESH, this.sortMode);
            break;
            case Const.RESULT_POST_UNSUCCESSFUL:
                this.displayMessageBlock(Const.POST_UNSUCCESSFUL, Const.CLASS_FILL_WARN);
            break;
            case Const.RESULT_ANONYMOUS_USER:
                this.displayMessageBlock(Const.POST_NOT_ALLOWED, Const.CLASS_FILL_ERROR);
                break;
        }
    }

    /**
     * Обновляет кол-во постов в строке "Комментарии (х)"
     * @param {number} replies
     */
    private updateSortMenuHeader(replies: number): void {
        this.$sortHeader.html(BaseUtils.sprintf(this.trans.getText('SORT_HEADER'), replies));
    }

    /**
     * Отображает предупреждение над полем ввода
     *
     * @param {string} text
     * @param warnClass
     */
    private displayWarning(text: string, warnClass: string = Const.CLASS_INFO): void {
        this.$warningMessage.html(text);
        this.$warningPanel.removeClass(Const.CLASS_HIDE);
        this.$warningPanel.addClass(warnClass);
    }

    /**
     * Показать анимированную "крутилку"
     */
    private runAnimatedLoader(): void {
        this.$loader.show();
    }

    /**
     * Скрыть анимированную "крутилку"
     */
    private stopAnimatedLoader(): void {
        this.$loader.hide();
    }

    /**
     * Разворачивает панель ввода сообщения
     */
    private expandPanel(): void {
        if (this.uid === Const.ANONYMOUS
        ) {
            if (window.innerWidth > Const.BREAKPOINT) {
                this.displayMessageBlock('LOGIN_PROMPT');
            } else {
                this.displayMessageBlock('LOGIN_PROMPT_SHORT');
            }
        }
        this.$controlBar.removeClass(Const.CLASS_HIDE);
        this.$textarea.css('height', Const.TEXT_AREA.expanded.height);
        this.broadcastMessage(Const.MESSAGE_RESIZE);
    }

    /**
     * Сжимает панель ввода сообщения
     */
    private shrinkPanel(): void {
        this.$controlBar.addClass(Const.CLASS_HIDE);
        this.$textarea.removeClass(Const.CLASS_TA_FOCUSED);
        this.$textarea.css('height', Const.TEXT_AREA.shrinked.height);
        this.clearMessageBlock();
        this.broadcastMessage(Const.MESSAGE_RESIZE);
    }

    /**
     * Передаём родительскому окну сообщения о ресайзе или необходимости обновить список постов
     *
     * @param {string} messageType
     * @param {number} sortMode
     */
    private broadcastMessage(messageType: string, sortMode: number = Const.SORT_ASC): void {
        let message = new BroadcastMessage(messageType, this.uuid, this.topicId, sortMode);

        switch (messageType) {
            case Const.MESSAGE_RESIZE:
                message.height = this.$body.height();
                break;
            case Const.MESSAGE_REFRESH:
                message.height = this.$body.height();
                break;
            case Const.MESSAGE_RELOAD_BOARD:
                message.height = this.$body.height();
                break;
        }

        if (typeof message !== 'undefined') {
            parent.postMessage(message, '*');
        }
    }

    /**
     * Сохраняет сообщение в хранилище (локальном или сессионном)
     */
    private savePostIntoStorage(): void {
        let text = <string>this.$textarea.val();
        if (text.length) {
            if (this.hasStorage) {
                window[this.storageType].setItem(Const.STORAGE_KEY, JSON.stringify(new ForumMessage(text, new Date().getTime() + Const.EXPIRE)));
            }
        }
    }

    /**
     * Достаёт сообщение из хранилища и
     * либо помещает текст в поле ввода,
     * либо удаляет (из хранилища), если "срок годности" сообщения истёк
     */
    private getPostFromStorage(): void {
        if (this.hasStorage
        ) {
            let json = window[this.storageType].getItem(Const.STORAGE_KEY);
            if (json !== null) {
                let message = JSON.parse(json);
                if (this.isExpired(message)) {
                    this.removePostFromStorage();
                } else {
                    this.$textarea.val(message.text).focus();
                    this.expandPanel();
                }
            }
        }
    }

    /**
     * Удаляет сообщение из хранилища
     *
     * @private
     */
    private removePostFromStorage(): void {
        if (this.hasStorage
        ) {
            window[this.storageType].removeItem(Const.STORAGE_KEY);
        }
    }

    // noinspection JSMethodCanBeStatic
    /**
     * Проверка "срока годности" сохранённого в хранилище сообщения
     *
     * @param message
     * @return {boolean}
     */
    private isExpired(message: any): boolean {
        return message.expire < new Date().getTime();
    }

    /**
     * Проверка на наличие хранилища
     *
     * @return {boolean}
     */
    private supports_html5_storage(): boolean {
        try {
            return this.storageType in window && window[this.storageType] !== null;
        } catch (e) {
            return false;
        }
    }
}
